export const COMING_SOON_FEATURES = Object.freeze({
  conceptCapsules: Object.freeze({
    title: 'Concept Capsules',
    comingSoon: true,
  }),
  predictedBoardExam: Object.freeze({
    title: 'Predicted Exam',
    comingSoon: true,
  }),
  marketplace: Object.freeze({
    title: 'Marketplace',
    comingSoon: true,
  }),
});
